import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import {InvoiceService, WorkspacesService} from '../services';

@Injectable({
  providedIn: 'root'
})
export class InvoiceApprovalGuard implements CanActivate {

  constructor(
      private invoiceService: InvoiceService,
      private workspaceService: WorkspacesService,
      private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const invoiceId = route.paramMap.get('invoiceId');
    const workspaceId = route.paramMap.get('workspaceId');

    if (!invoiceId || !workspaceId) {
      this.router.navigate(['/not-found']);
      return false;
    }

    try {
      this.workspaceService.setWorkspaceId(workspaceId);
      const response: any = await this.invoiceService.getInvoiceByIDFromAPI(workspaceId, invoiceId).toPromise();

      let invoice = null;
      if (response && response.content && response.content.length > 0) {
        invoice = response.content[0];
      } else if (response && response.invoiceNumber) {
        invoice = response;
      }

      if (invoice && invoice.approvalStatus === 'APPROVED') {
        return true;
      } else {
        this.router.navigate(['/notfound']);
        return false;
      }
    } catch (error) {
      console.error('Error checking invoice approval:', error);
      this.router.navigate(['/notfound']);
      return false;
    }
  }
}
